'use client';

interface Props {
  startDate: string;
  endDate: string;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
}

function formatDate(date: Date): string {
  return date.toISOString().split('T')[0];
}

export default function DateRangePicker({ startDate, endDate, onStartDateChange, onEndDateChange }: Props) {
  const applyPreset = (days: number) => {
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - days);
    onStartDateChange(formatDate(start));
    onEndDateChange(formatDate(end));
  };

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <input
        type="date"
        value={startDate}
        onChange={(e) => onStartDateChange(e.target.value)}
        className="px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-blue-500"
      />
      <span className="text-gray-500">~</span>
      <input
        type="date"
        value={endDate}
        onChange={(e) => onEndDateChange(e.target.value)}
        className="px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-blue-500"
      />
      <div className="flex gap-1">
        {[
          { label: '7일', days: 7 },
          { label: '30일', days: 30 },
        ].map(preset => (
          <button
            key={preset.label}
            onClick={() => applyPreset(preset.days)}
            className="px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-gray-300 text-sm hover:bg-gray-700 transition-colors"
          >
            {preset.label}
          </button>
        ))}
      </div>
    </div>
  );
}
